import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const PdfGeneratorApi = createApi(config.PDFGENERATOR_API_URL);

export default PdfGeneratorApi;
